// extracted by mini-css-extract-plugin
export default {"icon":"_8dwOKeljQybvG9ZRdaUQKg==","description":"_8ulDWrqUGdN6XXFKVsdL+Q==","handle":"gDq8doiAe1fXQ-wzFD+RAw=="};